(function () {
	'use strict';

	angular.module('qbePortal').directive('qbEmptyTableValidation', ['aggregatedRemoveService', function (aggregatedRemoveService) {
		return {
			restrict: 'AE',
			scope: {
				tableData: '<',
				ngModel: '<',
				trigger: '<',
				validYears: '<',
			},
			link: function (scope, elm, attrs, ctrl) {
				function tableHasData(rows) {
					var hasData = false;
					if (rows && rows.length > 0) {
						var removedData = aggregatedRemoveService.getList();
						if (!angular.isArray(removedData)) {
							return true;
						}

						rows.some(function (row) {
							if (removedData.indexOf(row) === -1) {
								hasData = true;
								return true;
							}
						});
					}
					return hasData;
				}

				var months = {
					'January': '01',
					'February': '02',
					'March': '03',
					'April': '04',
					'May': '05',
					'June': '06',
					'July': '07',
					'August': '08',
					'September': '09',
					'October': '10',
					'November': '11',
					'December': '12',
				};
				
				/*
				* Function - validate year position via index
				* Params - table data, year length
				* Return - boolean
				*/
				function validMonths(rows, validYears) {
					var isMonthValid = true;
					var lastYearIndex = validYears.length - 1;
					angular.forEach(validYears, function (years, index) {
						if (isMonthValid) {
							for (var i = 0; rows.length > i; i++) {
								if (years.value == rows[i].year.value && isMonthValid) {
									if (index == 0) {
										var month = rows[i].month.value;
										isMonthValid = getEligibleMonths(months[month], true);
									}
									else if (index == lastYearIndex) {
										var month = rows[i].month.value;
										isMonthValid = getEligibleMonths(months[month], false);
									} else {
										isMonthValid = true;
									}
								}
							}
						}
					})
					return isMonthValid;
				}

				/*
				* Function - validate month input against current month
				* Params - month, is current year
				* Return - boolean
				*/				
				function getEligibleMonths(month, currentYear) {
					var validMonth = true;
					var currentMonth = moment().tz("Australia/Sydney").format("M");

					if (!currentYear && parseInt(currentMonth) >= parseInt(month)) {
						validMonth = false;
					}

					if (currentYear && parseInt(month) > parseInt(currentMonth)) {
						validMonth = false;
					}

					return validMonth;
				}

				// scope.$on('table-number-of-rows-changed', function() {
				//   validateTable();
				// });

				scope.$on('form-submitted', function () {
					validateTable();
				});

				function validateTable() {
					if (scope.trigger) {
						scope.ngModel.$setValidity('qbEmptyTableValidation', tableHasData(scope.tableData));
						if (scope.validYears)
							scope.ngModel.$setValidity('qbInvalidMonth', validMonths(scope.tableData, scope.validYears));
					}
					else {
						scope.ngModel.$setValidity('qbEmptyTableValidation', true);
						if (scope.validYears)
							scope.ngModel.$setValidity('qbInvalidMonth', true);						
					}
						
				}
			}
		};
	}]);
})();
